document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-card__add-to-cart').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = this.dataset.productId;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: id, quantity: 1})
      })
      .then(res => res.json())
      .then(data => { alert('Added to cart'); })
      .catch(err => console.error(err));
    });
  });
});